import React, { useState, useContext } from 'react';
import AuthContext from '../context/AuthContext';

const CreateDog = ({ onSuccess }) => {
  const { getToken } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    name: '',
    breed: '',
    age_years: 0,
    age_months: 0,
    sex: 'unknown',
    size: 'medium',
    weight_kg: 0,
    temperament: '',
    walking_behaviour: '',
    lead_requirements: ''
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch('/api/dogs', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${getToken()}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (!response.ok) throw new Error(data.error);

      setSuccess(`${data.name} added successfully!`);
      setFormData({
        name: '',
        breed: '',
        age_years: 0,
        age_months: 0,
        sex: 'unknown',
        size: 'medium',
        weight_kg: 0,
        temperament: '',
        walking_behaviour: '',
        lead_requirements: ''
      });
      onSuccess();
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="form-panel">
      <h2>Add Dog Profile</h2>
      {error && <p className="error">{error}</p>}
      {success && <p className="success">{success}</p>}
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          name="name"
          placeholder="Dog Name"
          value={formData.name}
          onChange={handleChange}
          required
        />
        <input
          type="text"
          name="breed"
          placeholder="Breed"
          value={formData.breed}
          onChange={handleChange}
        />
        <div className="two-col">
          <input
            type="number"
            name="age_years"
            placeholder="Age (years)"
            value={formData.age_years}
            onChange={handleChange}
            min="0"
          />
          <input
            type="number"
            name="age_months"
            placeholder="Age (months)"
            value={formData.age_months}
            onChange={handleChange}
            min="0"
            max="11"
          />
        </div>
        <div className="two-col">
          <select name="sex" value={formData.sex} onChange={handleChange}>
            <option value="unknown">Sex</option>
            <option value="male">Male</option>
            <option value="female">Female</option>
          </select>
          <select name="size" value={formData.size} onChange={handleChange}>
            <option value="small">Small</option>
            <option value="medium">Medium</option>
            <option value="large">Large</option>
            <option value="xl">XL</option>
          </select>
        </div>
        <input
          type="number"
          name="weight_kg"
          placeholder="Weight (kg)"
          value={formData.weight_kg}
          onChange={handleChange}
          min="0"
          step="0.1"
        />
        <textarea
          name="temperament"
          placeholder="Temperament"
          value={formData.temperament}
          onChange={handleChange}
        />
        <textarea
          name="walking_behaviour"
          placeholder="Walking Behaviour"
          value={formData.walking_behaviour}
          onChange={handleChange}
        />
        <textarea
          name="lead_requirements"
          placeholder="Lead Requirements"
          value={formData.lead_requirements}
          onChange={handleChange}
        />
        <button type="submit">Create Dog Profile</button>
      </form>
    </div>
  );
};

export default CreateDog;
